import { combineReducers } from "redux";
import finance from "./finance";

const financeReducer = combineReducers({
    finance
});

export default financeReducer;
